// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"modal-wrapper--mp-BgK2u container--mp-BcHOL","modalWrapper":"modal-wrapper--mp-BgK2u container--mp-BcHOL"};